module.exports = __webpack_public_path__ + "static/img/sr5.fbd740e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sr5.jpg
// module id = xN35
// module chunks = 0